import { render, staticRenderFns } from "./view_empty.vue?vue&type=template&id=4b6790db&scoped=true"
import script from "./view_empty.vue?vue&type=script&lang=js"
export * from "./view_empty.vue?vue&type=script&lang=js"
import style0 from "./view_empty.vue?vue&type=style&index=0&id=4b6790db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6790db",
  null
  
)

export default component.exports